/*
 * notifications.js — esbuild IIFE entry
 * Thin wrapper that bundles the already-migrated module with its dependencies.
 * The Sprockets version (app/assets/javascripts/notifications.js) is deleted.
 */
require('./modules/v4/notifications_grid');
